import { TProductItemConfig } from '@/components/modules/orders-page/orders/ui/product-item';
import { getStatusOrder } from '@/components/modules/orders-page/utils/get-status-order';
import { TOrder } from '@/types/orders';

export const getUiConfig = (order: TOrder): TProductItemConfig => {
    const status = getStatusOrder(order);

    return { status, termUnit: order.product?.term_unit, isBuyout: order.rentProduct.is_buyout };
};
